import React, { useState } from 'react';
import { Edit2, Info, HeartPulse, Sparkles, ChevronDown, ChevronUp, CreditCard } from 'lucide-react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ReferenceLine, ResponsiveContainer } from 'recharts';
const pulseScoreData = [{
  month: 'Apr 25',
  score: 78,
  isKeyEvent: false
}, {
  month: 'May 25',
  score: 75,
  isKeyEvent: false
}, {
  month: 'Jun 25',
  score: 72,
  event: 'Financial statement: Revenue growth slowed to 2%',
  isKeyEvent: true
}, {
  month: 'Jul 25',
  score: 68,
  isKeyEvent: false
}, {
  month: 'Aug 25',
  score: 62,
  event: 'News: Key product launch delayed by 6 months',
  isKeyEvent: true
}, {
  month: 'Sep 25',
  score: 55,
  event: 'Financial statement: Revenue declined 8% YoY',
  isKeyEvent: true
}, {
  month: 'Oct 25',
  score: 48,
  event: 'Trade data: Payment terms extended to 45 days',
  isKeyEvent: true
}, {
  month: 'Nov 25',
  score: 42,
  event: 'People: CFO Michael Bolton departed company',
  isKeyEvent: true
}, {
  month: 'Dec 25',
  score: 38,
  event: 'People: VP Sales departed, 20% staff reduction',
  isKeyEvent: true
}, {
  month: 'Jan 26',
  score: 32,
  event: 'News: Major client contract lost to competitor',
  isKeyEvent: true
}, {
  month: 'Feb 26',
  score: 28,
  event: 'Financial statement: Revenue down 35% YoY, negative cash flow',
  isKeyEvent: true
}, {
  month: 'Mar 26',
  score: 28,
  isKeyEvent: false
}];
const healthScoreData = [{
  month: 'Apr 25',
  score: 82
}, {
  month: 'May 25',
  score: 80
}, {
  month: 'Jun 25',
  score: 76
}, {
  month: 'Jul 25',
  score: 72,
  event: 'Financial statement: Margins compressed 5%',
  isKeyEvent: true
}, {
  month: 'Aug 25',
  score: 68
}, {
  month: 'Sep 25',
  score: 62,
  event: 'Financial statement: Working capital concerns',
  isKeyEvent: true
}, {
  month: 'Oct 25',
  score: 55
}, {
  month: 'Nov 25',
  score: 48,
  event: 'Financial statement: Z-Score declined to 1.8',
  isKeyEvent: true
}, {
  month: 'Dec 25',
  score: 42
}, {
  month: 'Jan 26',
  score: 35,
  event: 'Financial statement: Debt-to-equity at 3.2x',
  isKeyEvent: true
}, {
  month: 'Feb 26',
  score: 28
}, {
  month: 'Mar 26',
  score: 28
}];
const paymentScoreData = [{
  month: 'Apr 25',
  score: 85
}, {
  month: 'May 25',
  score: 83
}, {
  month: 'Jun 25',
  score: 80
}, {
  month: 'Jul 25',
  score: 78
}, {
  month: 'Aug 25',
  score: 72
}, {
  month: 'Sep 25',
  score: 65,
  event: 'DBT increased from 15 to 22 days',
  isKeyEvent: true
}, {
  month: 'Oct 25',
  score: 55,
  event: 'DBT increased to 30 days',
  isKeyEvent: true
}, {
  month: 'Nov 25',
  score: 45
}, {
  month: 'Dec 25',
  score: 35,
  event: 'DBT increased to 45 days',
  isKeyEvent: true
}, {
  month: 'Jan 26',
  score: 25,
  event: 'Trade data: Multiple late payments reported',
  isKeyEvent: true
}, {
  month: 'Feb 26',
  score: 20
}, {
  month: 'Mar 26',
  score: 20
}];
function PositiveIndicator() {
  return <div className="flex items-end gap-0.5 shrink-0 mt-1" data-id="element-2446" data-mp="3oqqdupvk4xyk">
      <div className="w-1 h-1.5 bg-green-500 rounded-sm" data-id="element-2447" data-mp="2r6nhga46qqsa" />
      <div className="w-1 h-2.5 bg-green-500 rounded-sm" data-id="element-2448" data-mp="2w45nnsqtirwl" />
      <div className="w-1 h-3.5 bg-green-500 rounded-sm" data-id="element-2449" data-mp="2w4p0iv1m2q3r" />
    </div>;
}
function NegativeIndicator() {
  return <div className="flex items-end gap-0.5 shrink-0 mt-1" data-id="element-2450" data-mp="311noswylg2u1">
      <div className="w-1 h-1.5 bg-red-500 rounded-sm" data-id="element-2451" data-mp="35v0d15zd27m9" />
      <div className="w-1 h-2.5 bg-red-500 rounded-sm" data-id="element-2452" data-mp="28f2x1ve7hopy" />
      <div className="w-1 h-3.5 bg-red-500 rounded-sm" data-id="element-2453" data-mp="28eku6fx1gc92" />
    </div>;
}
function ScoreTooltip({
  active,
  payload,
  label,
  color
}: any) {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    const dotColor = data.score !== undefined ? getDotColor(data.score) : color;
    return <div className="bg-white rounded-lg border border-gray-200 shadow-lg px-4 py-3 max-w-[250px]" data-id="element-2454" data-mp="dwji2q2msf9e">
        <div className="flex items-center justify-between mb-2" data-id="element-2455" data-mp="splhuogcv2za">
          <p className="text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2456" data-mp="nw0m7328il39">
            {label}
          </p>
          <div className="flex items-center gap-1.5" data-id="element-2457" data-mp="11mdtr4b7rxs2">
            <div className="w-2 h-2 rounded-full" style={{
            backgroundColor: dotColor
          }} data-id="element-2458" data-mp="xndcvrcar57p" />
            <span className="text-sm font-bold text-gray-900" data-id="element-2459" data-mp="1bk0jymxyrbrc">
              {payload[0].value}
            </span>
          </div>
        </div>
        {data.event && <p className="text-sm text-gray-700 leading-snug border-t border-gray-100 pt-2 mt-1" data-id="element-2460" data-mp="3de9l8vw4s09q">
            {data.event}
          </p>}
      </div>;
  }
  return null;
}
function getDotColor(score: number) {
  if (score <= 30) return '#ef4444';
  if (score <= 70) return '#eab308';
  return '#22c55e';
}
const CustomDot = (props: any) => {
  const {
    cx,
    cy,
    payload
  } = props;
  const color = getDotColor(payload.score);
  if (payload.isKeyEvent) {
    return <g data-id="element-2461" data-mp="1j543r0k47k68">
        <circle cx={cx} cy={cy} r={12} fill={color} fillOpacity={0.2} className="animate-pulse" data-id="element-2462" data-mp="1j4ug3jmjlp3p" />
        <circle cx={cx} cy={cy} r={6} fill="#ffffff" stroke={color} strokeWidth={3} data-id="element-2463" data-mp="1a4xwvxix9ig1" />
      </g>;
  }
  return <circle cx={cx} cy={cy} r={3} fill={color} stroke={color} strokeWidth={2} data-id="element-2464" data-mp="vab8eq5ke607" />;
};
const CustomActiveDot = (props: any) => {
  const {
    cx,
    cy,
    payload
  } = props;
  const color = getDotColor(payload.score);
  return <circle cx={cx} cy={cy} r={8} fill={color} stroke="#fff" strokeWidth={2} data-id="element-2465" data-mp="2uksrhu570n83" />;
};
export function InitechOverviewTab() {
  const [healthExpanded, setHealthExpanded] = useState(true);
  const [paymentExpanded, setPaymentExpanded] = useState(true);
  return <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-2466" data-mp="2o3hk0wrch06a">
      {/* Top Row */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-2467" data-mp="2j7si4mrur76t">
        {/* Credit Settings */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-5 lg:col-span-1" data-id="element-2468" data-mp="2f678daam790u">
          <div className="flex justify-between items-center mb-6" data-id="element-2469" data-mp="3bwhk0o0qfgjm">
            <h3 className="text-lg font-bold text-gray-900" data-id="element-2470" data-mp="36wlfmno4hn3j">Credit Settings</h3>
            <button className="w-8 h-8 bg-indigo-600 hover:bg-indigo-700 rounded-full flex items-center justify-center text-white transition-colors" data-id="element-2471" data-mp="323sba0wkggrz">
              <Edit2 className="w-4 h-4" data-id="element-2472" data-mp="2y0w0gwd9poyl" />
            </button>
          </div>
          <div className="grid grid-cols-2 gap-y-3 gap-x-4" data-id="element-2473" data-mp="3umfs344j59n9">
            <div data-id="element-2474" data-mp="3ptmleapi3r8j">
              <p className="text-sm font-semibold text-gray-900 mb-0.5" data-id="element-2475" data-mp="3pt3erq5awp9t">
                Credit Limit
              </p>
              <p className="text-sm text-gray-600" data-id="element-2476" data-mp="1cd32y95csgdo">$75,000</p>
            </div>
            <div className="relative group" data-id="element-2477" data-mp="1hbmow9jy5s61">
              <p className="text-sm font-semibold text-gray-900 mb-0.5" data-id="element-2478" data-mp="1hcfzxmpxv3tz">
                Recommended Limit
              </p>
              <p className="text-sm text-red-600" data-id="element-2479" data-mp="1qb1c904thmmb">$0</p>
              <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-900 text-white text-xs rounded px-2 py-1 whitespace-nowrap z-10" data-id="element-2480" data-mp="1qckwt2xiajtw">
                Apr 15, 2025: Approved for $75,000 credit
              </div>
            </div>
            <div data-id="element-2481" data-mp="24zxjww2yoxme">
              <p className="text-sm font-semibold text-gray-900 mb-0.5" data-id="element-2482" data-mp="251h0yowfzcp8">
                Outstanding Balance
              </p>
              <p className="text-sm text-red-600 font-semibold" data-id="element-2483" data-mp="290zpdunh25wt">$68,000</p>
            </div>
            <div data-id="element-2484" data-mp="2e2p0196s8hkd">
              <p className="text-sm font-semibold text-gray-900 mb-0.5" data-id="element-2485" data-mp="2dz13e161jf1f">
                Utilization
              </p>
              <p className="text-sm text-red-600 font-semibold" data-id="element-2486" data-mp="1twjgtnchpq3k">91%</p>
            </div>
            <div data-id="element-2487" data-mp="1oxp1ivdqejo7">
              <p className="text-sm font-semibold text-gray-900 mb-0.5" data-id="element-2488" data-mp="1oy885fxxllmx">
                AP Contact
              </p>
              <p className="text-sm text-gray-600" data-id="element-2489" data-mp="22wgc47tdxn7l">Milton Waddams</p>
            </div>
            <div data-id="element-2490" data-mp="1yvczdu6mw7al">
              <p className="text-sm font-semibold text-gray-900 mb-0.5" data-id="element-2491" data-mp="1ywxsrgh7pk6v">
                Terms
              </p>
              <p className="text-sm text-gray-600" data-id="element-2492" data-mp="1b6tnz5safeea">Net 30</p>
            </div>
            <div data-id="element-2493" data-mp="168a0v21yjwkc">
              <p className="text-sm font-semibold text-gray-900 mb-0.5" data-id="element-2494" data-mp="168s62o6lll4e">
                Company Officer
              </p>
              <p className="text-sm text-gray-600" data-id="element-2495" data-mp="1k0qa4klgcqtp">Bill Lumbergh</p>
            </div>
            <div data-id="element-2496" data-mp="1f6m0ftksy4ox">
              <p className="text-sm font-semibold text-gray-900 mb-0.5" data-id="element-2497" data-mp="1f62hc9jf1a9b">
                Date Last Reviewed
              </p>
              <p className="text-sm text-gray-600" data-id="element-2498" data-mp="ngz9ykw8fjsg">2/15/2026</p>
            </div>
            <div data-id="element-2499" data-mp="newli5aq9ypu">
              <p className="text-sm font-semibold text-gray-900 mb-0.5" data-id="element-2500" data-mp="dd2dlco1wz4s">
                Group
              </p>
              <p className="text-sm text-gray-600" data-id="element-2501" data-mp="i3r7eyn7e873">Software</p>
            </div>
          </div>
        </div>

        {/* Pulse Score */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-5 lg:col-span-2 flex flex-col" data-id="element-2502" data-mp="3gfx102rcu8k">
          <div className="flex items-center gap-2 mb-4" data-id="element-2503" data-mp="8blixyw5u8wn">
            <h3 className="text-xl font-bold text-gray-900" data-id="element-2504" data-mp="w4bqzx0y081n">Pulse Score</h3>
          </div>
          <div className="flex gap-6 mb-6" data-id="element-2505" data-mp="112n36eepmun1">
            <div className="bg-red-100 rounded-lg p-4 flex flex-col items-center justify-center min-w-[120px] shrink-0" data-id="element-2506" data-mp="110alm2cv6mai">
              <span className="text-4xl font-bold text-gray-900" data-id="element-2507" data-mp="r477dy4qmx77">28</span>
              <span className="text-sm font-medium text-gray-800 mt-1" data-id="element-2508" data-mp="r2cpytsodn7v">
                High Risk
              </span>
            </div>
            <p className="text-gray-600 text-base leading-relaxed pt-2" data-id="element-2509" data-mp="3bu6giaxircbe">
              Pulse Score of 28 indicates high risk and should be reviewed.
              Score has deteriorated dramatically over 10 months from 78 in
              April 2025.
            </p>
          </div>
          <div className="flex-1 min-h-[200px] relative" data-id="element-2510" data-mp="1q1vbxp95erxj">
            <div className="absolute top-0 right-0 flex items-center gap-2 text-xs text-gray-500 z-10" data-id="element-2511" data-mp="1bacstikzsh9y">
              <div className="w-3 h-3 bg-black rounded-sm" data-id="element-2512" data-mp="1g8mtg8phka2y"></div>
              Pulse Score
            </div>
            <ResponsiveContainer width="100%" height="100%" data-id="element-2513" data-mp="1294zzg18w8n9">
              <LineChart data={pulseScoreData} margin={{
              top: 20,
              right: 10,
              left: -20,
              bottom: 10
            }} data-id="element-2514" data-mp="179sy0lnw5pqz">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" data-id="element-2515" data-mp="xbli865c9dqk" />
                <XAxis dataKey="month" axisLine={false} tickLine={false} tick={{
                fontSize: 12,
                fill: '#6B7280'
              }} dy={10} data-id="element-2516" data-mp="2rpmfwnp5jup2" />
                <YAxis domain={[0, 100]} ticks={[0, 25, 50, 75, 100]} axisLine={false} tickLine={false} tick={{
                fontSize: 12,
                fill: '#6B7280'
              }} data-id="element-2517" data-mp="psc8gbsx7d0z" />
                <Tooltip content={<ScoreTooltip data-id="element-2519" data-mp="uqnnd0y2odq2" />} cursor={{
                stroke: '#E5E7EB',
                strokeWidth: 2,
                strokeDasharray: '4 4'
              }} data-id="element-2518" data-mp="upvp1id3c1w3" />
                <ReferenceLine y={70} stroke="#22c55e" strokeDasharray="4 4" data-id="element-2520" data-mp="13psg1qmydcub" />
                <ReferenceLine y={30} stroke="#ef4444" strokeDasharray="4 4" data-id="element-2521" data-mp="3aibdodikz7zw" />
                <Line type="monotone" dataKey="score" stroke="#000000" strokeWidth={2} dot={<CustomDot data-id="element-2523" data-mp="1eeevc0ctji5x" />} activeDot={<CustomActiveDot data-id="element-2524" data-mp="1efgeyt7whcz9" />} data-id="element-2522" data-mp="35k9vduszbcph" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      {/* Health Score */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-2525" data-mp="1ngo68rc01dju">
        <button onClick={() => setHealthExpanded(!healthExpanded)} className="w-full p-5 flex items-center justify-between bg-white hover:bg-gray-50 transition-colors border-b border-gray-100" data-id="element-2526" data-mp="1sdmxn24a36ec">
          <div className="flex items-center gap-3" data-id="element-2527" data-mp="2250zhgjpcian">
            <HeartPulse className="w-5 h-5 text-gray-700" data-id="element-2528" data-mp="266masxgl8oiq" />
            <h3 className="text-xl font-bold text-gray-900" data-id="element-2529" data-mp="26873sin97zeh">Health Score</h3>
            <div className="flex items-center gap-2 px-3 py-1 rounded-full border-2 border-red-500 bg-white ml-2" data-id="element-2530" data-mp="2b6qs2ppblna0">
              <div className="w-2.5 h-2.5 rounded-full bg-red-500" data-id="element-2531" data-mp="2g4k0zqi0cvdz"></div>
              <span className="text-base font-bold text-gray-900" data-id="element-2532" data-mp="2q90dc9wa3ud1">28</span>
            </div>
            <Sparkles className="w-4 h-4 text-indigo-400 ml-1 animate-sparkle cursor-pointer" title="Ask Pulse AI about this score" data-id="element-2533" data-mp="2l82t7rrpkq8w" />
          </div>
        </button>

        {healthExpanded && <div className="p-5" data-id="element-2534" data-mp="2caiuaphbj61g">
            <p className="text-base text-gray-600 mb-6" data-id="element-2535" data-mp="38yf9bpx3xtak">
              INITECH has a 45.8% probability of insolvency or bankruptcy in the
              next 12 months.
            </p>
            <div className="grid grid-cols-1 lg:grid-cols-4 gap-6" data-id="element-2536" data-mp="2z8vt6s0s4dje">
              {/* Negative Factors */}
              <div className="border border-gray-200 rounded-lg p-4" data-id="element-2537" data-mp="2v7jyw96yn44v">
                <h4 className="text-sm font-bold text-gray-900 mb-4 pb-2 border-b border-gray-100" data-id="element-2538" data-mp="2v57iw1krj3ug">
                  Negative Impact Factors
                </h4>
                <div className="space-y-3" data-id="element-2539" data-mp="3mxexyxkme86q">
                  <div className="flex items-start gap-2" data-id="element-2540" data-mp="3mwn2rnuxqcgz">
                    <NegativeIndicator data-id="element-2541" data-mp="37fovj17akbhw" />
                    <span className="text-sm text-gray-600" data-id="element-2542" data-mp="37it56e3izzfy">
                      Revenue decline (-35% YoY) with negative EBITDA and cash
                      burn
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-2543" data-mp="32h3rsrstz9op">
                    <NegativeIndicator data-id="element-2544" data-mp="32hnbacy4q64u" />
                    <span className="text-sm text-gray-600" data-id="element-2545" data-mp="3q77t2sijqxcj">
                      2 CxOs departed in Q4 2025
                    </span>
                  </div>
                </div>
              </div>

              {/* Positive Factors */}
              <div className="border border-gray-200 rounded-lg p-4" data-id="element-2546" data-mp="3hdurl26f2neu">
                <h4 className="text-sm font-bold text-gray-900 mb-4 pb-2 border-b border-gray-100" data-id="element-2547" data-mp="3lfg3olb4mxnz">
                  Positive Impact Factors
                </h4>
                <div className="space-y-3" data-id="element-2548" data-mp="cyl8ls0kmhkg">
                  <div className="flex items-start gap-2" data-id="element-2549" data-mp="hs6bnyh0u1qi">
                    <PositiveIndicator data-id="element-2550" data-mp="22hjv95rhegx9" />
                    <span className="text-sm text-gray-600" data-id="element-2551" data-mp="22gi7q1ta41yn">
                      Long operating history (33 years)
                    </span>
                  </div>
                </div>
              </div>

              {/* Chart */}
              <div className="lg:col-span-2 h-[200px]" data-id="element-2552" data-mp="2c9fsyfpno50y">
                <ResponsiveContainer width="100%" height="100%" data-id="element-2553" data-mp="2780a8uayaalq">
                  <LineChart data={healthScoreData} margin={{
                top: 10,
                right: 10,
                left: -20,
                bottom: 0
              }} data-id="element-2554" data-mp="1jiph9yzudki5">
                    <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" data-id="element-2555" data-mp="1tesecqfu6sy8" />
                    <XAxis dataKey="month" hide data-id="element-2556" data-mp="34uh1pix05tzk" />
                    <YAxis domain={[0, 100]} ticks={[0, 20, 40, 60, 80, 100]} axisLine={false} tickLine={false} tick={{
                  fontSize: 12,
                  fill: '#6B7280'
                }} data-id="element-2557" data-mp="2zx7fsd8to0gh" />
                    <Tooltip content={<ScoreTooltip color="#ef4444" data-id="element-2559" data-mp="3gw8qkou0bq4t" />} data-id="element-2558" data-mp="3gz37459wgqsy" />
                    <Line type="monotone" dataKey="score" stroke="#000000" strokeWidth={2} dot={<CustomDot data-id="element-2561" data-mp="2t7xt7vnis8la" />} activeDot={<CustomActiveDot data-id="element-2562" data-mp="2t6mp1uq5wytn" />} data-id="element-2560" data-mp="3lwd6acn3cgtz" />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>}
      </div>

      {/* Payment Score */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-2563" data-mp="25jek5dwnbrs5">
        <button onClick={() => setPaymentExpanded(!paymentExpanded)} className="w-full p-5 flex items-center justify-between bg-white hover:bg-gray-50 transition-colors border-b border-gray-100" data-id="element-2564" data-mp="2ai9b534romnc">
          <div className="flex items-center gap-3" data-id="element-2565" data-mp="nl9u2abmylkb">
            <CreditCard className="w-5 h-5 text-gray-700" data-id="element-2566" data-mp="njf60n52idc0" />
            <h3 className="text-xl font-bold text-gray-900" data-id="element-2567" data-mp="ilds0gmi147e">Payment Score</h3>
            <div className="flex items-center gap-2 px-3 py-1 rounded-full border-2 border-red-500 bg-white ml-2" data-id="element-2568" data-mp="dnvf6f5d24u4">
              <div className="w-2.5 h-2.5 rounded-full bg-red-500" data-id="element-2569" data-mp="8paob6c00xic"></div>
              <span className="text-base font-bold text-gray-900" data-id="element-2570" data-mp="3xsmyh62cuwu">20</span>
            </div>
            <Sparkles className="w-4 h-4 text-indigo-400 ml-1 animate-sparkle cursor-pointer" title="Ask Pulse AI about this score" data-id="element-2571" data-mp="3w13bqshpe32y" />
          </div>
        </button>

        {paymentExpanded && <div className="p-5" data-id="element-2572" data-mp="3m24339wxu7fy">
            <p className="text-base text-gray-600 mb-6" data-id="element-2573" data-mp="3m59p2ga9st7g">
              INITECH has a 78.5% probability of late payment, indicating very
              high risk. Payment behavior was strong until September 2025 but
              has since deteriorated significantly.
            </p>
            <div className="grid grid-cols-1 lg:grid-cols-4 gap-6" data-id="element-2574" data-mp="1dtxl36nif0h1">
              {/* Negative Factors */}
              <div className="border border-gray-200 rounded-lg p-4" data-id="element-2575" data-mp="zug2j90t4jg4">
                <h4 className="text-sm font-bold text-gray-900 mb-4 pb-2 border-b border-gray-100" data-id="element-2576" data-mp="14spz9o26js3u">
                  Negative Impact Factors
                </h4>
                <div className="space-y-3" data-id="element-2577" data-mp="uvcv5hxcu14z">
                  <div className="flex items-start gap-2" data-id="element-2578" data-mp="uweiolvk4g3l">
                    <NegativeIndicator data-id="element-2579" data-mp="h4gdgm4yv4cp" />
                    <span className="text-sm text-gray-600" data-id="element-2580" data-mp="h5rjytpsqq7i">
                      DBT spiked 200% (15 → 45 days) and 15 days past due
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-2581" data-mp="7720wxm5yzpo">
                    <NegativeIndicator data-id="element-2582" data-mp="c53s65tqu5c8" />
                    <span className="text-sm text-gray-600" data-id="element-2583" data-mp="c429bf6hkejy">
                      Using 91% of available credit ($68K/$75K)
                    </span>
                  </div>
                </div>
              </div>

              {/* Positive Factors */}
              <div className="border border-gray-200 rounded-lg p-4" data-id="element-2584" data-mp="2hhsna0m786y">
                <h4 className="text-sm font-bold text-gray-900 mb-4 pb-2 border-b border-gray-100" data-id="element-2585" data-mp="2isw18q5edxj">
                  Positive Impact Factors
                </h4>
                <div className="space-y-3" data-id="element-2586" data-mp="bh4hkwc5qlj4">
                  <div className="flex items-start gap-2" data-id="element-2587" data-mp="bg34ynfhtqza">
                    <PositiveIndicator data-id="element-2588" data-mp="7fj6ngj6ohbk" />
                    <span className="text-sm text-gray-600" data-id="element-2589" data-mp="7erphaqc2m4t">
                      New interim CFO hired in January 2026
                    </span>
                  </div>
                </div>
              </div>

              {/* Chart */}
              <div className="lg:col-span-2 h-[200px]" data-id="element-2590" data-mp="v5dlu4qz6hyz">
                <ResponsiveContainer width="100%" height="100%" data-id="element-2591" data-mp="v42ejuybms34">
                  <LineChart data={paymentScoreData} margin={{
                top: 10,
                right: 10,
                left: -20,
                bottom: 0
              }} data-id="element-2592" data-mp="q8dcnkytwz3n">
                    <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" data-id="element-2593" data-mp="1bqrz4tnhdhju" />
                    <XAxis dataKey="month" hide data-id="element-2594" data-mp="jz2kl6hbjdla" />
                    <YAxis domain={[0, 100]} ticks={[0, 20, 40, 60, 80, 100]} axisLine={false} tickLine={false} tick={{
                  fontSize: 12,
                  fill: '#6B7280'
                }} data-id="element-2595" data-mp="jzu4hk1jzmvq" />
                    <Tooltip content={<ScoreTooltip color="#ef4444" data-id="element-2597" data-mp="a9zkkol6ysz" />} data-id="element-2596" data-mp="athw2i5fp7j" />
                    <Line type="monotone" dataKey="score" stroke="#000000" strokeWidth={2} dot={<CustomDot data-id="element-2599" data-mp="3i94841iu4nur" />} activeDot={<CustomActiveDot data-id="element-2600" data-mp="3n25ralq2r9k5" />} data-id="element-2598" data-mp="8yxcpashz3z" />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>}
      </div>
    </div>;
}